import { HeaderButtonConfig } from '@api/types';
import { MdIcon } from '@components';
import { Badge, Box, BoxProps, styled } from '@mui/material';
import { palette } from '@themes/theme.helpers';
import { ReactNode } from 'react';

// STYLES
//--------
const ButtonWrapper = styled(Box)`
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  transition: height 300ms linear, width 300ms linear;
  color: ${palette.primary('contrastText')};
  background: none;
  border: none;
  padding: 0;
`;

const StyledBadge = styled(Badge)``;

// TYPES
//-------
export type HeaderIconButtonProps = BoxProps &
  HeaderButtonConfig & {
    badgeContent?: ReactNode;
  };

// COMPONENTS
//------------

export const HeaderIconButton = ({
  title,
  iconName,
  badgeContent,
  ...boxProps
}: HeaderIconButtonProps) => {
  const icon = <MdIcon iconName={iconName} sx={{ fontSize: 24 }} />;
  return (
    <ButtonWrapper
      component='button'
      className='site-header-button'
      {...boxProps}
      title={title}
      aria-label={title}
    >
      {badgeContent ? (
        <StyledBadge badgeContent={badgeContent} color='error'>
          {icon}
        </StyledBadge>
      ) : (
        icon
      )}
    </ButtonWrapper>
  );
};
